<template>
    <div class="head">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/images/logo.png" alt="logo" />
        </router-link>
      </div>
      <div  class="nav">
        <el-menu
          :default-active="this.$store.getters.getActiveIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          router
        >
          <el-menu-item route="/" index="1">网站首页</el-menu-item>
          <el-menu-item route="/hecheng" index="2">合成配音</el-menu-item>
          <el-menu-item route="/peiyin" index="3">主播简介</el-menu-item>
          <el-menu-item route="/about" index="4">联系我们</el-menu-item>
          <el-menu-item route="/vip" index="5">捐赠本站</el-menu-item>
          <el-menu-item route="/waimai" index="6">外卖神券</el-menu-item>
          <el-menu-item route="/tuiwen" index="7">
            <el-badge value="Beta" class="item">
            推文视频生成
            </el-badge>
          </el-menu-item>
        </el-menu>
      </div>
      <div v-if="Object.keys(this.$store.getters.getUserInfo).length===0" class="sign">
        <el-row>
          <span @click="login" style='cursor:pointer;'>
            <img :src="require('../assets/images/qq_login.png')" />
          </span>
        </el-row>
      </div>
      <div v-else class="user-info">
        <el-dropdown @command="handleCommand">
          <div  class="loggedIn">
                  <div  class="phoneLogin">
                    <i class="el-icon-user-solid"></i>
                    <div  class="userId userId-colors">
                        <span >{{userInfo.username}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </div>
                </div>
              </div>
         
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="work" icon="el-icon-s-cooperation">工作台</el-dropdown-item>
              <el-dropdown-item command="loginOut" icon="el-icon-switch-button">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  mounted(){
    let token = this.$route.query.token
    console.log(this.$route.query.token)
    if(token != undefined && String(token).length > 0){
      //console.log("set token---:"+token)
      this.$store.commit("setToken",token)
      //console.log("token is "+this.$store.getters.getToken)


      window.location.href="/"
    }else{
      this.loginInfo()
    }
    
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    login(){
    
      var A=window.open("/login/qq","TencentLogin","width=450,height=320,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1");
    },
    loginInfo(){
      //if(this.$store.getters.getToken != "" && Object.keys(this.$store.getters.getUserInfo).length === 0){


        this.axios({
          method: "post",
          url: "/qq/info",
          data: {},
        }).then((res) => {
          if(res.data.code == "200"){
            this.$store.commit("setUserInfo",res.data.data)
            this.userInfo = this.$store.getters.getUserInfo
          }else{
            this.$store.commit("setUserInfo",{})
            this.userInfo = this.$store.getters.getUserInfo
          }
        }).catch((err) => {
          console.log(err);
        });
      //}
      console.log(this.userInfo)
      
    },
    loginOut(){
      console.log("loginout")
      this.axios({
        method: "post",
        url: "/login/out",
        data: {},
      }).then((res) => {
        if(res.data.code == "200"){
          this.$store.commit("setUserInfo",{})
          this.userInfo = this.$store.getters.getUserInfo
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    handleCommand(cmd){
      if(cmd == "loginOut"){
        this.loginOut()
      }else if(cmd == "work"){
        window.location.href="/#/workspace"
      }
    }
  },
};
</script>
<style>
  .el-menu-item,.el-submenu__title{
    font-size: 1rem !important;
  }
  .user-info {
    display: flex;
    align-items: center;
    width: 20%;
    justify-content: flex-end;
    margin-left: 3.33333vw;
  }
  .phoneLogin {
      display: flex;
      align-items: center;
      position: relative;
  }
  .phoneLogin:hover {
    background: #f5f9ff;
    color:#409EFF;
    padding:10px;
  }
  .userId {
    font-size: 0.73333vw;
    font-family: PingFang SC;
    font-weight: 300;
    padding-left:10px;
  }
  .nav sup.el-badge__content{
    top:11px!important;
  }
</style>